import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ContentProvider } from "./contexts/ContentContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import ScrollToTopButton from "./components/ScrollToTopButton";
import FloatingContact from "./components/FloatingContact";
import CookieBanner from "./components/CookieBanner";
import HomePage from "./pages/HomePage";

const AboutPage = lazy(() => import("./pages/AboutPage"));
const SectorsPage = lazy(() => import("./pages/SectorsPage"));
const FocusPage = lazy(() => import("./pages/FocusPage"));
const PartnersPage = lazy(() => import("./pages/PartnersPage"));
const ContactPage = lazy(() => import("./pages/ContactPage"));
const ProductsPage = lazy(() => import("./pages/ProductsPage"));
const PrivacyPage = lazy(() => import("./pages/PrivacyPage"));
const TermsPage = lazy(() => import("./pages/TermsPage"));
const CareersPage = lazy(() => import("./pages/CareersPage"));
const FAQPage = lazy(() => import("./pages/FAQPage"));
const PressPage = lazy(() => import("./pages/PressPage"));
const NotFoundPage = lazy(() => import("./pages/NotFoundPage"));

function PageFallback() {
    return (
        <div className="min-h-[40vh] flex items-center justify-center text-navy-600">
            <div className="animate-pulse text-sm tracking-wider uppercase">Loading…</div>
        </div>
    );
}

function App() {
    return (
        <HelmetProvider>
            <ContentProvider>
                <Router>
                    <ScrollToTop />
                    <a
                        href="#main"
                        className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:bg-brand-deep focus:text-white focus:px-4 focus:py-2 focus:rounded-lg"
                    >
                        Skip to content
                    </a>
                    <div className="App flex flex-col min-h-screen bg-white">
                        <Header />
                        <main id="main" className="flex-grow">
                            <Suspense fallback={<PageFallback />}>
                                <Routes>
                                    <Route path="/" element={<HomePage />} />
                                    <Route path="/about" element={<AboutPage />} />
                                    <Route path="/sectors" element={<SectorsPage />} />
                                    <Route path="/focus" element={<FocusPage />} />
                                    <Route path="/partners" element={<PartnersPage />} />
                                    <Route path="/products" element={<ProductsPage />} />
                                    <Route path="/contact" element={<ContactPage />} />
                                    <Route path="/privacy" element={<PrivacyPage />} />
                                    <Route path="/terms" element={<TermsPage />} />
                                    <Route path="/careers" element={<CareersPage />} />
                                    <Route path="/faq" element={<FAQPage />} />
                                    <Route path="/press" element={<PressPage />} />
                                    <Route path="*" element={<NotFoundPage />} />
                                </Routes>
                            </Suspense>
                        </main>
                        <Footer />
                        <ScrollToTopButton />
                        <FloatingContact />
                        <CookieBanner />
                    </div>
                </Router>
            </ContentProvider>
        </HelmetProvider>
    );
}

export default App;
